import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {BsThreeDots} from "react-icons/bs";
import {usePagination, DOTS} from "./usePagination";
import "./pagination.scss";

const Pagination = (props) => {
  const {currentPage, onPageChange = () => {}, totalCount, pageSize = 25} = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    pageSize,
  });

  const lastPage = paginationRange[paginationRange.length - 1];

  const onNext = () => {
    if (currentPage !== lastPage) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage !== 1) {
      onPageChange(currentPage - 1);
    }
  };

  return (
    <Fragment>
      <div className="Table__pagination" data-cy={"pagination-component"}>
        <button
          className="Table__pageButton table_first"
          onClick={onPrevious}
          disabled={currentPage === 1}
          data-cy="prev-btn"
        >
          {"Prev."}
        </button>
        {paginationRange.map((pageNumber, index) => {
          return (
            <Fragment key={index}>
              {pageNumber === DOTS ? (
                <button className="Table__pageButton" style={{cursor: "not-allowed"}}>
                  <BsThreeDots />
                </button>
              ) : (
                <button
                  key={pageNumber}
                  className={`Table__pageButton ${
                    currentPage === pageNumber ? "Table__pageButton--active" : ""
                  }`}
                  style={{cursor: "not-allowed"}}
                  data-cy={"page-btn"}
                >
                  {pageNumber}
                </button>
              )}
            </Fragment>
          );
        })}
        <button
          className="Table__pageButton table_last"
          data-cy="next-btn"
          onClick={onNext}
          disabled={currentPage === lastPage}
        >
          {"Next."}
        </button>
      </div>
    </Fragment>
  );
};

Pagination.propTypes = {
  /** this prop will determine active page of pagination component */
  currentPage: PropTypes.number.isRequired,
  /** this prop tells total number of items we are displaying */
  totalCount: PropTypes.number.isRequired,
  /** this prop determines number of items to show per page */
  pageSize: PropTypes.number,
  /** this function will be executed when user clicks on previous or next button with new page number */
  onPageChange: PropTypes.func,
};

export default Pagination;
